export const removeFromFavoritesCategoryText = "a_XBgd";
export default {removeFromFavoritesCategoryText};